<template>

<core-modal v-on:close="onClose" :trackScroll="true" :has-sticky="true" :initialScroll="initialScroll" :nopadding="true" icon="caret-left" v-on:scroll="onScroll">

	<template v-slot:head>

		Select Filter

	</template>

	<template v-slot:sticky>

		<div class="directory-search">

			<input type="text" ref="search" v-model="search" placeholder="Quick search..." />

			<i class="fa fa-solid fa-magnifying-glass" />

		</div>

		<div class="directory-tags">

			<div v-for="item in types" v-on:click="onTypeClick(item)" :class="{'is-faded': type && item !== type}" :key="item" class="directory-tags-item" :data-name="item" v-tooltip="'Click to quick filter'">{{ item }}</div>

		</div>

	</template>

	<template v-slot:default>

		<com-filter :item="filter" v-for="(filter, index) in filtersFinal" :key="index" v-on:click="onFilterClick" />

	</template>

</core-modal>

</template>

<script>

import $filter from '@/filter'
import comFilter from './directory/Filter'

export default {
	
    props: ['data'],

	components: {
		'com-filter': comFilter
	},

	data: function() {

		return {
			search: '',
			type: '',
			scroll: 0,
			initialScroll: 0,
			types: ['User', 'Game', 'BGG', 'Collection', 'Plays', 'Ratings']
		}

	},

	created: function() {

		var defaultValues = this.$store.getters['data/stash']['filter/directory'];

		if (defaultValues) {

			this.search = defaultValues.search
			this.type = defaultValues.type
			this.initialScroll = defaultValues.scroll

		}

		this.$nextTick(function() {

			this.$refs.search.focus()

		}.bind(this))

	},

	computed: {

		filters: function() {

			return $filter.types

		},

		filtersFinal: function() {

			var term = this.search.toLowerCase().trim()

			var filters = this.filters

			if (term.length) {
			
				filters = this.$_.filter(filters, function(type) {

					var category = (this.$_.isArray(type.lang.category)) ? type.lang.category.join(' ') : type.lang.category

					return category.toLowerCase().indexOf(term) >= 0 || type.lang.name.toLowerCase().indexOf(term) >= 0 || type.lang.description.toLowerCase().indexOf(term) >= 0

				}.bind(this))

			}

			if (this.type) {
			
				filters = this.$_.filter(filters, function(type) {

					return (this.$_.isArray(type.lang.category)) ? this.$_.contains(type.lang.category, this.type) : type.lang.category === this.type

				}.bind(this))

			}
			
			filters = this.$_.filter(filters, function(type) {

				return (!type.usage.self || this.isSelf) && !type.usage.linkOnly

			}.bind(this))
			
			filters = this.$_.sortBy(filters, function(type) {

				return type.lang.name

			})

			return filters

		}

	},

	methods: {

		onScroll: function(e) {

			this.scroll = e.y

		},
		
		onTypeClick: function(value) {

			this.type = (this.type === value) ? '' : value

		},

		onFilterClick: function(value) {

			this.$store.commit('data/stash', {
				name: 'filter/directory',
				value: {
					search: this.search,
					type: this.type,
					scroll: this.scroll
				}
			})

			this.$pubsub.$emit('open.modal', {
				id: 'filterRule',
				filterName: this.data.filterName,
				group: this.data.group,
				type: value
			})

		},

		onClose: function() {
			
			this.$store.commit('data/stash', {
				name: 'filter/directory',
				value: {
					search: '',
					type: '',
					scroll: 0
				}
			})

			this.$emit('close')

		}

	}

}

</script>

<style scoped>

.directory-search {
	margin: 10px;
	border-radius: 4px;
	background-color: #fff;
}

.is-mobile .directory-search {
	border: 1px solid #eee;
	border-radius: 10px;
	margin: 0px 10px 10px 10px;
}

.directory-search input {
	height: 32px;
	width: 100%;
	color: #343434;
	padding: 0px 10px;
	font-size: 14px;
}

.directory-search input::placeholder {
	color: #999;
}

.directory-search .fa {
	position: absolute;
	right: 15px;
	top: 0px;
	line-height: 32px;
	font-size: 16px;
	color: #2b5870;
}

.is-mobile .directory-search .fa {
	color: #343434;
	right: 10px;
}

.directory-tags {
	display: grid;
	margin: 0px 10px 0px 10px;
	padding-bottom: 10px;
	grid-gap: 2px;
    border-bottom: 1px solid rgb(54, 97, 119);
	grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
}

.is-mobile .directory-tags {
	border-bottom: 1px solid #eee;
	margin: 0px;
	padding: 0px 10px 10px 10px;
	box-shadow: rgba(9, 30, 66, 0.25) 0px 4px 8px -2px;
}

.directory-tags-item {
    font-weight: 500;
    line-height: 12px;
    font-size: 12px;
    border-radius: 4px;
	text-align: center;
    padding: 2px 4px;
    color: #0a2b3d;
	cursor: pointer;
}

.directory-tags-item.is-faded {
	opacity: 0.3;
}

.directory-tags-item[data-name="User"] {
    background-color: #E9C46A;
}

.directory-tags-item[data-name="Game"] {
    background-color: #CBA6F7;
}

.directory-tags-item[data-name="BGG"] {
    background-color: #6EC5E9;
}

.directory-tags-item[data-name="Plays"] {
    background-color: #E9A6A6;
}

.directory-tags-item[data-name="Collection"] {
    background-color: #90E0A9;
}

.directory-tags-item[data-name="Ratings"] {
    background-color: #E27B64;
}

.directory-tags-item:not(.is-faded):hover {
	filter: brightness(0.75);
}

.directory-tags-item.is-faded:hover {
	opacity: 1;
}

</style>